import type {
  ArticleType,
  PageType,
} from '@city-of-helsinki/react-helsinki-headless-cms';
import { isLanguage } from '@city-of-helsinki/react-helsinki-headless-cms';
import {
  Notification,
  useLanguagesQuery,
} from '@city-of-helsinki/react-helsinki-headless-cms/apollo';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { useContext } from 'react';
import { NavigationContext } from '../../navigationProvider';
import type { Language, Menu } from '../../types';
import styles from './navigation.module.scss';
import useGetItemIsActive from './useGetIsItemActive';
import useGetPathnameForLanguage from './useGetPathnameForLanguage';

type NavigationProps = {
  readonly page?: PageType | ArticleType;
  readonly menu?: Menu;
  readonly universalBarMenu?: Menu;
  readonly languages?: Language[];
};

const RHHCNavigationNoSSR = dynamic(
  () =>
    import('@city-of-helsinki/react-helsinki-headless-cms').then(
      (mod) => mod.Navigation
    ),
  {
    ssr: false,
  }
);

export default function Navigation({
  page,
  menu,
  universalBarMenu,
  languages: forcedLanguages, // FIXME: This is here only to skip the Apollo query and so the issues in the Error page
}: NavigationProps) {
  const { headerMenu, headerUniversalBarMenu, languages } =
    useContext(NavigationContext);
  const router = useRouter();
  const getIsItemActive = useGetItemIsActive();
  const getPathnameForLanguage = useGetPathnameForLanguage(page);
  const languagesQuery = useLanguagesQuery({
    skip: !!languages || !!forcedLanguages,
  });
  const languageOptions =
    forcedLanguages ??
    languages ??
    languagesQuery.data?.languages?.filter(isLanguage);

  return (
    <>
      <RHHCNavigationNoSSR
        languages={languageOptions}
        menu={menu ?? headerMenu}
        universalBarMenu={universalBarMenu ?? headerUniversalBarMenu}
        className={styles.topNavigation}
        onTitleClick={() => {
          void router.push('/');
        }}
        getIsItemActive={getIsItemActive}
        getPathnameForLanguage={getPathnameForLanguage}
      />
      {/* CMS notification banner */}
      <Notification />
    </>
  );
}
